export default "__VITE_ASSET__3c183894__"